import { gql } from '@apollo/client';

const GENERATE_BADGE = gql`
    
    mutation generatePractitionerBadge(
        $practitionerId: Int!
        $qualification: String!
    ){
        generatePractitionerBadge(
            practitionerId: $practitionerId 
            qualification: $qualification
        )
    }
`;
export default GENERATE_BADGE;